import { IconButtonProps } from '@/components/IconButton';

export default {
  components: {
    styleOverrides: {
      root: ({ ownerState, theme }: { ownerState: any; theme: any }) => ({
        ...(ownerState.variant === 'circular' && {
          borderRadius: '50%'
        }),
        ...(ownerState.variant === 'rounded' && {
          borderRadius: 8
        }),
        ...(ownerState.variant === 'square' && {
          borderRadius: 0
        }),
        ...(ownerState.hasBg && {
          backgroundColor: ownerState?.bgColor || theme.palette.secondary.main
        })
      })
    },
    variants: [
      {
        props: {
          hasBg: true
        } as IconButtonProps,
        style: ({ theme, ownerState }: any) => ({
          '&:hover': {
            backgroundColor: ownerState?.bgColor || theme.palette.secondary.main
          }
        })
      }
    ]
  }
};
